import React, { useState, useEffect } from 'react';
import Axios from "axios";
import './../../../../assets/css/purchase/form.css';

// Components
import Breadcrumbs from '../../../components/Breadcrumbs';
import ArModal from '../../../components/Modal/ArModal';
import ItemWhTable from '../../../components/Content/ItemWhTable';
import SoModal from '../../../components/Modal/SoModal';
import DatePicker from '../../../components/DatePicker';
import FormAction from '../../../components/Actions/FormAction';

// Model
import { whDocMasterModel } from '../../../../model/Warehouse/WHDocMasterModel';
import { whDocDetailModel } from '../../../../model/Warehouse/WHDocDetailModel';

import {
  getData,
  getDataWithComp,
  getAlert,
  formatCurrency,
  parseCurrency,
  getSpRunNumber,
  getViewItem,
  updateQty
} from "../../../../utils/SamuiUtils";

import {
  formatDateTime,
  formatThaiDateUiToDate,
  setCreateDateTime,
} from "../../../../utils/DateUtils";

import { manageWhItemData } from '../../../../utils/WarehouseUtils';

const Form = ({ callInitialize, mode, setMode, name, whDocNo, getReport }) => {
  const [formMasterList, setFormMasterList] = useState(whDocMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [arDataList, setArDataList] = useState([]);
  const [soDataList, setSoDataList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  const [whDataList, setWhDataList] = useState([]);

  // การเลือกคลังจากหน้าจอ
  const [selectedWarehouseFrom, setSelectedWarehouseFrom] = useState(null);
  const [selectedArIdTo, setSelectedArIdTo] = useState(null);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    const whDataList = await getDataWithComp(
      "Tb_Set_Wh",
      "AND Flag_Vansale = 'N' AND WH_Status = 'Y' ORDER BY WH_Name ASC"
    );
    if (whDataList && whDataList.length > 0) {
      setWhDataList(whDataList);
    }

    const itemDataList = await getViewItem();
    if (itemDataList && itemDataList.length > 0) {
      setItemDataList(itemDataList);
    }

    const arDataList = await getDataWithComp(
      "Tb_Set_AR",
      "ORDER BY AR_Code ASC"
    );
    if (arDataList && arDataList.length > 0) {
      setArDataList(arDataList);
    }

    // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
    if (mode === 'U') {
      await getModelByNo();
    }
  };

  const getModelByNo = async () => {
    try {
      const fromDatabase = await getDataWithComp('WHDoc_H', `AND WHDoc_No = '${whDocNo}'`);

      if (!fromDatabase) {
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ฟังก์ชันดึงข้อมูล itemOnHand
      const getOnHand = async (whId, itemId) => {
        const itemOnHand = await getDataWithComp('API_1101_WH_ITEM_ONHAND', `AND WH_Id = ${parseCurrency(whId)} AND Item_Id = ${parseCurrency(itemId)}`);
        return itemOnHand[0].Item_Onhand;
      };

      // ฟังก์ชันสร้างแถวใหม่
      const createNewRow = (index, itemSelected, itemOnHand) => {
        return {
          ...whDocDetailModel(index + 1),
          dtId: itemSelected.DT_Id,
          whDocId: itemSelected.WHDoc_Id || null,
          line: itemSelected.Line || null,
          itemId: itemSelected.Item_Id || null,
          itemCode: itemSelected.Item_Code || null,
          itemName: itemSelected.Item_Name || null,
          itemOnHand: itemOnHand || null,
          itemQty: itemSelected.Item_Qty ? formatCurrency(itemSelected.Item_Qty) : null,
          itemOrder: null,
          itemBalance: parseCurrency(itemOnHand) - parseCurrency(itemSelected.Item_Qty),
          itemUnit: itemSelected.Item_Unit || null,
          itemPriceUnit: itemSelected.Item_Price_Unit || null,
          itemDiscount: null,
          itemDisType: null,
          itemTotal: itemSelected.Item_Total || null,
          docType: itemSelected.Doc_Type || null,
          refDocId: itemSelected.Ref_DocID || null,
          refDocNo: itemSelected.Ref_DocNo || null
        };
      };

      // ค้นหาข้อมูลของ Detail ด้วย WHDoc_Id
      const fromDetail = await getDataWithComp('API_1002_WHDOC_D', `AND WHDoc_Id = ${fromDatabase[0].WHDoc_Id} ORDER BY Line ASC`);

      if (fromDetail.length > 0) {
        // สร้าง Promises สำหรับ itemOnHand
        const itemOnHandPromises = fromDetail.map(item => getOnHand(fromDatabase[0].F_WH_Id, item.Item_Id));

        // รอ Promises
        const itemOnHandResults = await Promise.all(itemOnHandPromises);

        // สร้าง newFormDetails โดยใช้ itemOnHandResults
        const newFormDetails = fromDetail.map((item, index) => createNewRow(formDetailList.length + index, item, itemOnHandResults[index]));

        await handleChangeWarehouse(String(fromDatabase[0].F_WH_Id), 'FROM');

        setFormDetailList(newFormDetails);

        const data = fromDatabase[0];

        setFormMasterList({
          whDocId: data.WHDoc_Id,
          whDocNo: data.WHDoc_No,
          whDocType: data.WHDoc_Type,
          whDocCustId: data.WHDoc_Cust_Id,
          whDocCustCode: null,
          whDocCustName: null,
          whDocDate: data.WHDoc_Date,
          whDocTransDate: data.WHDoc_TransDate,
          whDocCreatedDate: setCreateDateTime(data.WHDoc_CreatedDate),
          whDocCreatedBy: data.WHDoc_CreatedBy,
          whDocStatus: data.WHDoc_Status,
          whDocSeq: data.WHDoc_SEQ,
          whDocRemark: data.WHDoc_Remark,
          whDocCompId: data.Comp_Id,
          whDocShowFront: data.WHDoc_ShowFront,
          refDocId: data.Ref_DocID,
          refDoc: null,
          refDocDate: null,

          // ใช้สำหรับแสดงเฉยๆ
          arAdd1: null,
          arAdd2: null,
          arAdd3: null,
          arProvince: null,
          arZipcode: null,
          arTaxNo: null,
        });
      } else {
        getAlert('FAILED', `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${fromDatabase[0].WHDoc_No} กรุณาตรวจสอบและลองอีกครั้ง`);
      }
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value ? value.format('YYYY-MM-DD') : null,
    }));
  };

  const handleQuantityChange = (index, type, value, onHand) => {
    // ดักค่าเพื่อให้ส่งมาอย่างถูกต้อง (จริงๆแล้วแทบไม่ได้ใช้)
    if (type !== 'decrease') {
      getAlert("FAILED", "พบข้อผิดพลาดในการดำเนินการ กรุณารีเฟชรแล้วลองใหม่");
    }

    // ตรวจสอบว่าค่าที่กรอกเข้ามาเป็นตัวเลขหรือตัวเลขที่มีจุดทศนิยม
    if (!/^\d*\.?\d*$/.test(value) || value === "") {
      return;
    }

    // หากผู้ใช้กรอกจุดทศนิยมอย่างเดียว (เช่น ".") ให้คงค่าเดิมไว้ก่อน
    if (value === ".") {
      const updatedList = [...formDetailList];
      updatedList[index].itemDecrease = value;
      updatedList[index].itemBalance = parseCurrency(onHand);
      setFormDetailList(updatedList);
      return;
    }

    const updatedList = [...formDetailList];

    // ดักไม่ให้ปรับปรุงเกินกว่าสินค้าคงเหลือ เฉพาะตอนปรับลดสินค้า
    if (parseCurrency(value) > parseCurrency(onHand)) {
      getAlert("FAILED", "กรุณาระบุจำนวนไม่เกินคงเหลือ");
      updatedList[index].itemDecrease = null;
      updatedList[index].docType = "AO";
      setFormDetailList(updatedList);
      return;
    }

    // ดักไม่ให้ปรับปรุงเกินกว่าสินค้าที่ใบขาย เฉพาะตอนปรับลดสินค้า
    if (parseCurrency(value) > parseCurrency(updatedList[index].itemRecQty)) {
      getAlert("FAILED", "กรุณาระบุจำนวนไม่เกินใบขาย");
      updatedList[index].itemDecrease = null;
      updatedList[index].docType = "AO";
      setFormDetailList(updatedList);
      return;
    }

    updatedList[index].docType = "AO";
    updatedList[index].itemDecrease = value;
    updatedList[index].itemQty = parseCurrency(value);
    updatedList[index].itemBalance = parseCurrency(onHand) - parseCurrency(value);

    setFormDetailList(updatedList);
  };

  const handleChangeWarehouse = async (value) => {
    try {
      const itemDataList = await getDataWithComp('Tb_Set_Item', `AND Item_Status = 'Y' ORDER BY Item_Code ASC`);
      if (itemDataList && itemDataList.length > 0) {
        setItemDataList(itemDataList);
      }

      const itemOnHandList = await getDataWithComp('API_1101_WH_ITEM_ONHAND', `AND WH_Id = ${parseCurrency(value)} ORDER BY Item_Code ASC`);

      // ถ้ามีข้อมูลใน itemOnHandList
      if (itemOnHandList && itemOnHandList.length > 0 && itemDataList && itemDataList.length > 0) {
        const filteredItemOnHandList = itemOnHandList.filter(itemOnHand =>
          itemDataList.some(itemData => itemData.Item_Id === itemOnHand.Item_Id)
        );

        setFormDetailList((prevDetailList) => {
          return prevDetailList.map((detail) => {
            const matchOnHand = filteredItemOnHandList.find(
              (stock) => stock.Item_Id === detail.itemId
            );

            const onHandQty = matchOnHand ? parseCurrency(matchOnHand.Item_Onhand) : 0;

            return {
              ...detail,
              itemOnHand: formatCurrency(onHandQty),
            };
          });
        });
      } else {
        // ถ้าไม่มีข้อมูลใน itemOnHandList ให้ค่า itemOnHand เป็น 0
        setFormDetailList((prevDetailList) => {
          return prevDetailList.map((detail) => {
            return {
              ...detail,
              itemOnHand: formatCurrency(0),  // ตั้งค่าเป็น 0
            };
          });
        });
      }

      setSelectedWarehouseFrom(value);
    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาดที่ไม่คาดคิด");
    }
  };

  const handleFocus = (index) => {
    const updatedList = [...formDetailList];
    updatedList[index].itemDecrease = parseCurrency(updatedList[index].itemDecrease) || 0;
    setFormDetailList(updatedList);
  };

  const handleBlur = (index) => {
    const updatedList = [...formDetailList];
    updatedList[index].itemDecrease = formatCurrency(updatedList[index].itemDecrease);
    setFormDetailList(updatedList);
  };

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);
  const onRowSelectItem = (itemsSelected) => {
    try {
      // ใช้ Set เพื่อกรอง Item_Id ที่ซ้ำกัน
      const uniqueItems = Array.from(
        new Set(itemsSelected.map(item => item.Item_Id))
      ).map(id => {
        return itemsSelected.find(item => item.Item_Id === id);
      });

      // อัปเดตรายการโดยคงค่าของสินค้าที่เคยมีอยู่
      const updatedFormDetailList = uniqueItems.map((itemSelected) => {
        // ค้นหาว่ามีสินค้าอยู่ใน formDetailList เดิมหรือไม่
        const existingItem = formDetailList.find(item => item.itemId === itemSelected.Item_Id);

        return {
          line: existingItem?.line || null,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: existingItem ? formatCurrency(existingItem.itemQty || 0) : formatCurrency(0),
          itemDecrease: existingItem ? formatCurrency(existingItem.itemDecrease || 0) : formatCurrency(0),
          itemUnit: existingItem ? existingItem.itemUnit : itemSelected.Item_Unit_ST,
          itemPriceUnit: existingItem ? existingItem.itemPriceUnit : formatCurrency(itemSelected.Item_Cost || 0),
          itemOnHand: existingItem ? existingItem.itemOnHand : formatCurrency(itemSelected.Item_Onhand || 0),
          itemTotal: existingItem ? existingItem.itemTotal : 0,
          docType: "AO",
          itemIsReturn: 0,
          itemReturnDate: null
        };
      });

      setFormDetailList(updatedFormDetailList);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };
  const handleRemoveRow = async (index) => {
    setFormDetailList([]);
    setTimeout(() => {
      const newList = formDetailList.filter((_, i) => i !== index);
      setFormDetailList(newList);
    }, 50);
  };

  // SET AR
  const [showArModal, setShowArModal] = useState(false);
  const handleArShow = () => setShowArModal(true);
  const handleArClose = () => setShowArModal(false);
  const onRowSelectAr = (arSelected) => {
    try {
      setSelectedArIdTo(arSelected.AR_Id);

      setFormMasterList({
        ...formMasterList,
        arID: arSelected.AR_Id,
        arCode: arSelected.AR_Code,
        arName: arSelected.AR_Name,
        arAdd1: arSelected.AR_Add1,
        arAdd2: arSelected.AR_Add2,
        arAdd3: arSelected.AR_Add3,
        arProvince: arSelected.AR_Province,
        arZipcode: arSelected.AR_Zipcode,
        arTaxNo: arSelected.AR_TaxNo,
        arItemFree: arSelected.AR_Item_Free,
      });

      if (arSelected.AR_Item_Free === "Y") {
        if (formDetailList.length > 0) {
          setFormDetailList([]);
          getAlert(
            "INFO",
            "ลูกค้านี้เป็นลูกค้าฟรี ระบบจะล้างข้อมูลรายการสินค้าโดยอัตโนมัติ"
          );
        }
      }

      handleArClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET SO
  const [showSoModal, setShowSoModal] = useState(false);
  const handleSoShow = async () => {
    let soDataList = await getDataWithComp(
      "API_0701_SO_H",
      `AND AR_Id = ${selectedArIdTo} AND DocStatusTransport_Name <> 'จัดส่งแล้ว' AND Doc_Status <> '13' ORDER BY Doc_No DESC`
    );

    if (soDataList && soDataList.length > 0) {
      setSoDataList(soDataList);
    }

    setShowSoModal(true);
  };
  const handleSoClose = () => setShowSoModal(false);
  const onRowSelectSo = async (soSelected) => {
    try {
      if (!Array.isArray(soSelected) || soSelected.length === 0) return;

      const selected = soSelected[0];

      if (mode === "I") {
        setFormDetailList([]);
      }

      setFormMasterList((prev) => ({
        ...prev,
        refDocId: selected.Doc_ID ?? null,
        refDoc: selected.Doc_No ?? '',
        refDocDate: selected.Doc_Date ?? '',
        arId: selected.AR_Id ?? null,
        arCode: selected.AR_Code ?? '',
        arName: selected.AR_Name ?? '',
        arAdd1: selected.AR_Add1 ?? '',
        arAdd2: selected.AR_Add2 ?? '',
        arAdd3: selected.AR_Add3 ?? '',
        arProvince: selected.AR_Province ?? '',
        arZipcode: selected.AR_Zipcode ?? '',
        arTaxNo: selected.AR_TaxNo ?? '',
      }));

      // ดึงรายละเอียดใบขาย
      const soDetailList = await getDataWithComp("API_0702_SO_D", `AND Doc_ID = ${selected.Doc_ID}`);
      if (!Array.isArray(soDetailList) || soDetailList.length === 0) return;

      // ดึงข้อมูล OnHand จาก WH ที่เลือก
      const whId = parseCurrency(selectedWarehouseFrom);
      const itemOnHandList = await getDataWithComp(
        'API_1101_WH_ITEM_ONHAND',
        `AND WH_Id = ${whId} ORDER BY Item_Code ASC`
      );

      const newDetailList = soDetailList
        .map((detail) => {

          if (parseCurrency(detail.Item_Qty) <= parseCurrency(detail.Item_Rec_Qty)) {
            return null;
          }
          const matchOnHand = itemOnHandList.find(
            (stock) => stock.Item_Id === detail.Item_Id
          );

          const onHandQty = matchOnHand ? parseCurrency(matchOnHand.Item_Onhand) : 0;

          return {
            line: detail.Line ?? '',
            itemId: detail.Item_Id ?? '',
            itemCode: detail.Item_Code ?? '',
            itemName: detail.Item_Name ?? '',
            itemOnHand: formatCurrency(onHandQty),
            itemUnit: detail.Item_Unit ?? '',
            itemQty: formatCurrency(detail.Item_Qty),
            itemDecrease: formatCurrency(parseCurrency(detail.Item_Qty - detail.Item_Rec_Qty)),
            itemRecQty: formatCurrency(parseCurrency(detail.Item_Qty - detail.Item_Rec_Qty)),
            docType: 'AO',
            refDocId: detail.Doc_ID ?? null,
            refDocNo: detail.Doc_No ?? '',
          };
        })
        .filter((item) => item !== null);

      setFormDetailList(newDetailList);

    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาดที่ไม่คาดคิด");
    }
  };
  const onConfirmSoSelection = async (soSelected) => {
    setFormDetailList([]);

    const hasVat = soSelected.some((so) => so.IsVat === 1);
    const hasNoVat = soSelected.some((so) => so.IsVat === 2);

    if (hasVat && hasNoVat) {
      getAlert(
        "FAILED",
        "ไม่สามารถเลือกใบขายสินค้าที่มี VAT และไม่มี VAT ร่วมกันได้"
      );
      return;
    }

    onRowSelectSo(soSelected);
    handleSoClose();
    getAlert("OK", "การเลือกใบขายสินค้าสำเร็จ");
  };

  const handleSubmit = async () => {
    try {
      if (!formDetailList || formDetailList.length === 0) {
        return getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้าที่จะส่ง");
      }

      for (const item of formDetailList) {
        const qty = parseCurrency(item.itemDecrease);
        const onHand = parseCurrency(item.itemOnHand);
        if (!qty || parseCurrency(qty) === 0) return getAlert("FAILED", `กรุณากรอกจำนวนส่งของสินค้า ${item.itemName}`);
        if (parseCurrency(qty) > parseCurrency(onHand)) return getAlert("FAILED", `กรุณากรอกจำนวนส่งของสินค้า ${item.itemName} ต้องน้อยกว่าจำนวนคงคลัง`);
      }

      const wh_doc_no = await getSpRunNumber("ST");
      const formMasterData = {
        wh_doc_no,
        wh_doc_type: 5,
        wh_doc_cust_id: parseCurrency(formMasterList.whDocCustId, 10),
        wh_doc_date: formMasterList.whDocDate,
        wh_doc_trans_date: formMasterList.whDocTransDate,
        wh_doc_created_date: formatThaiDateUiToDate(formMasterList.whDocCreatedDate),
        wh_doc_created_by: formMasterList.whDocCreatedBy,
        wh_doc_status: 3,
        wh_doc_seq: formatDateTime(new Date()),
        wh_doc_remark: formMasterList.whDocRemark,
        wh_doc_comp_id: formMasterList.whDocCompId,
        wh_doc_show_front: null,
        ref_doc_id: formMasterList.refDocId,
        f_wh_id: selectedWarehouseFrom,
        f_zone_id: formMasterList.fZoneId,
        f_lt_id: formMasterList.fLtId,
        t_wh_id: selectedArIdTo,
        t_zone_id: formMasterList.fZoneId,
        t_lt_id: formMasterList.fLtId
      };

      const response = await Axios.post(`${process.env.REACT_APP_API_URL}/api/create-wh-doc-h`, formMasterData, {
        headers: { key: process.env.REACT_APP_ANALYTICS_KEY }
      });

      if (response.data.status === 'OK') {
        const getWhDocIdResponse = await Axios.post(`${process.env.REACT_APP_API_URL}/api/get-by-wh-doc-no`, {
          table: 'WHDoc_H',
          wh_doc_no,
          comp_id: window.localStorage.getItem('company')
        }, {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY }
        });

        const whDocId = parseCurrency(getWhDocIdResponse?.data?.[0]?.WHDoc_Id || 0);
        let line = 1;

        const detailData = formDetailList.map((item) => ({
          wh_doc_id: whDocId,
          line: line++,
          item_id: item.itemId,
          item_code: item.itemCode,
          item_name: item.itemName,
          item_qty: parseCurrency(item.itemDecrease),
          item_unit: item.itemUnit,
          item_price_unit: parseCurrency(item.itemPriceUnit),
          item_total: parseCurrency(item.itemTotal),
          doc_type: item.docType,
          ref_doc_id: item.refDocId,
          item_is_return: item.itemIsReturn,
          item_return_date: item.itemReturnDate
        }));

        await Promise.all(detailData.map(data => Axios.post(`${process.env.REACT_APP_API_URL}/api/create-wh-doc-d`, data, {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY }
        })));

        // ตัด Stock จากคลังเดิม && Update จำนวนรับของใบขาย
        for (const item of formDetailList) {
          // #####################################
          // เอาออกจากคลังตามจำนวนสินค้าที่ใบขาย
          // #####################################
          await manageWhItemData(
            item.itemId, // Item ไอดีของสิ่งนั้นๆ
            item.itemCode, // Item โค้ดของสิ่งนั้นๆ
            item.itemName, // ชื่อ Item นั้นๆ
            selectedWarehouseFrom, // WarehouseID ของไอเทม
            "OUT", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
            parseCurrency(item.itemDecrease), // ค่าจำนวนที่กรอกจากหน้าจอ
            whDocId, // ไอดีเอกสาร
            wh_doc_no, // เลขเอกสาร
            formMasterList.refDoc === null
              ? wh_doc_no
              : formMasterList.refDoc, // เลขเอกสารอ้างอิง
            "ส่งสินค้า" // หมายเหตุ
          );

          // Update จำนวนรับของใบขาย
          let findSoDetail = await getData(
            "SO_D",
            `Doc_ID = ${formMasterList.refDocId} AND Item_Id = ${item.itemId}`
          );
          if (findSoDetail && findSoDetail.length > 0) {
            let itemRecQtyOld = parseCurrency(findSoDetail[0].Item_Rec_Qty) || 0;
            let itemDecreaseQty = parseCurrency(item.itemDecrease) || 0;
            let newQty = itemRecQtyOld + itemDecreaseQty;

            // update ค่าใหม่
            await updateQty(
              "SO_D",
              `Item_Rec_Qty = ${newQty}`,
              `WHERE Doc_ID = ${formMasterList.refDocId} AND Item_Id = ${item.itemId}`
            );
          }
        }

        // ถ้าใบขายนี้ทำการรับสินค้าครบทั้งหมดแล้ว ให้หยอดสถานะว่ารับครบแล้วที่ SO_H
        const soDetail = await getData("SO_D", `Doc_ID = ${formMasterList.refDocId}`);
        if (soDetail && soDetail.length > 0) {

          let totalItem = 0;
          let totalItemRec = 0;

          for (const detail of soDetail) {
            totalItem += parseCurrency(detail.Item_Qty);
            totalItemRec += parseCurrency(detail.Item_Rec_Qty);
          }

          // ตรวจว่ารับครบหรือเกิน
          if (totalItemRec >= totalItem) {
            await updateQty(
              "SO_H",
              `Doc_Status_Transport = '3'`,
              `WHERE Doc_ID = ${formMasterList.refDocId}`
            );
          }
        }

        if (getReport) {
          try {
            await getReport('pd', wh_doc_no);
          } catch (e) {
            console.error('Print error:', e);
          }
        }

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdate = async () => {
    // ยังไม่มี Business ตรงนี้
  };

  const handleCancel = async () => {
    // ยังไม่มี Business ตรงนี้
  };

  return <>
    <div hidden={window.location.pathname === '/picking-list'}>
      <Breadcrumbs page={whDocNo} items={[
        { name: 'คลังสินค้า', url: '/Warehouse' },
        { name: name, url: '/bill-of-lading' },
        { name: mode === 'U' ? "เรียกดู" + name : "สร้าง" + name, url: '#' }
      ]} />
    </div>

    <div className="body">
      <div class="container-fluid my-4">
        <div className="row mb-1">
          <div className="col-4">
            <DatePicker
              label="วันที่เอกสาร"
              name="whDocDate"
              value={formMasterList.whDocDate}
              onChange={(date) => handleChangeDateMaster(date, "whDocDate")}
              disabled={mode === "U"}
            />
          </div>
          <div className="col-4">
            <div className="d-flex">
              <label>จากคลัง : </label>
              <select
                class="form-select"
                value={selectedWarehouseFrom}
                onChange={(e) => handleChangeWarehouse(e.target.value)}>
                <option value={null}>
                  กรุณาระบุคลัง
                </option>
                {whDataList.map((warehouse) => (
                  <option
                    key={warehouse.WH_Id}
                    value={warehouse.WH_Id}
                  >
                    {warehouse.WH_Name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex">
              <label>สร้างโดย : </label>
              <input
                type="text"
                className="form-control input-spacing"
                value={formMasterList.whDocCreatedBy}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mb-1">
          <div className="col-4">
            <DatePicker
              label="วันที่จัดส่ง"
              name="whDocTransDate"
              value={formMasterList.whDocTransDate}
              onChange={(date) => handleChangeDateMaster(date, "whDocTransDate")}
              disabled={
                formMasterList.refDocId !== null
                  || formMasterList.whDocStatus === 3
                  || formMasterList.whDocStatus === 13
                  ? true
                  : false
              }
            />
          </div>
          <div className="col-4">
            <div className="d-flex">
              <label>ส่งไปที่ลูกค้า :</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="apCode"
                  value={
                    (formMasterList.arCode || "") +
                    " " +
                    (formMasterList.arName || "")
                  }
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleArShow}
                  disabled={mode === "U" ? true : false}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
              <ArModal
                showArModal={showArModal}
                handleArClose={handleArClose}
                arDataList={arDataList}
                onRowSelectAr={onRowSelectAr}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex">
              <label className="">วันที่สร้าง : </label>
              <input
                type="text"
                className="form-control input-spacing"
                value={formMasterList.whDocCreatedDate}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mb-1">
          <div className="col-4">
            <div className="d-flex">
              <label>อ้างอิงเอกสาร : </label>
              {/* <input
                type="text"
                className="form-control input-spacing"
                name="refDoc"
                value={formMasterList.refDoc || ''}
                onChange={handleChangeMaster}
                disabled={true}
              /> */}

              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="refDoc"
                  value={formMasterList.refDoc || ""}
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => selectedArIdTo === null ? getAlert('FAILED', 'กรุณาระบุลูกค้าก่อน') : handleSoShow()}
                  disabled={mode === "U"}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
              <SoModal
                showSoModal={showSoModal}
                handleSoClose={handleSoClose}
                soDataList={soDataList}
                onConfirmSoSelection={onConfirmSoSelection}
                arId={formMasterList.arID}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex">
              <label>หมายเหตุ : </label>
              <input
                type="text"
                className="form-control input-spacing"
                name="whDocRemark"
                value={formMasterList.whDocRemark || ''}
                onChange={handleChangeMaster}
                disabled={formMasterList.refDocId !== null || formMasterList.whDocStatus === 3 || formMasterList.whDocStatus === 13 ? true : false}
              />
            </div>
          </div>
          <div className="col-4" />
        </div>
        <div className="row mb-1">
          <div className="col-4">
            <DatePicker
              label="วันที่เอกสารอ้างอิง"
              name="refDocDate"
              value={formMasterList.refDocDate}
              onChange={(date) => handleChangeDateMaster(date, "refDocDate")}
              disabled={true}
            />
          </div>
          <div className="col-4" />
        </div>
      </div>
      <hr />
    </div>
    <div className="container-fluid my-3">
      <div className="row">
        <div className="col-12">
          <ItemWhTable
            mode={mode}
            showItemModal={showItemModal}
            handleItemClose={handleItemClose}
            itemDataList={itemDataList}
            onRowSelectItem={onRowSelectItem}
            formDetailList={formDetailList}
            handleItemShow={handleItemShow}
            handleQuantityChange={handleQuantityChange}
            handleFocus={handleFocus}
            handleBlur={handleBlur}
            handleRemoveRow={handleRemoveRow}
            formatCurrency={formatCurrency}
            disabled={selectedWarehouseFrom === null}
          />
          <FormAction
            onSubmit={handleSubmit}
            onUpdate={handleUpdate}
            onCancel={handleCancel}
            onHandleClick={() => getReport && getReport("pd", formMasterList.whDocNo || whDocNo)}
            mode={mode}
            setMode={setMode}
            disabled={formMasterList.refDocId !== null || formMasterList.whDocStatus === 3 || formMasterList.whDocStatus === 13 ? true : false}
            footer={window.location.pathname === '/picking-list' ? false : true}
          />
        </div>
      </div>
    </div>
  </>
};

export default Form;